import { useState } from "react";
import Navbar from "../Navbar";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Env from "../../runtimeEnv";

function SurveyForm() {
  const navigate = useNavigate();

  const [answers, setAnswers] = useState({});
  const [disqualified, setDisqualified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { PlutonicuserID, email, setSurveyCompleted, handleLogout, verifyUserAccessFromServer   } = useContext(AuthContext);

  const questions = [
    {
      id: 1,
      text: "The AI companion is not a licensed therapist. Do you agree?",
      disqualifyOn: "No",
    },
    // {
    //   id: 2,
    //   text: "Is support, coping tools, and guided check-ins what you're looking for?",
    //   disqualifyOn: null,
    // }, // ✅ no disqualification
    /* {
      id: 3,
      text: "Do you agree to use the AI alongside professional care?",
      disqualifyOn: "No",
    }, */
    {
      id: 2,
      text: "Are you currently in inpatient psychiatric care or a crisis stabilization program?",
      disqualifyOn: "Yes",
    },
    // {
    //   id: 4,
    //   text: "Do you have a condition requiring close medical supervision?",
    //   disqualifyOn: "Yes",
    // },
    {
      id: 3,
      text: "Over the past month, have you often felt overwhelmed to the point of self-harm thoughts?",
      disqualifyOn: "Yes",
    },
    /*{ id: 6, text: "Do you feel safe right now?", disqualifyOn: null },*/ // ✅ no disqualification
  ];

  const handleChange = (id, value) => {
    setAnswers((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);

    const userEmail = localStorage.getItem("email") || email;
    if (!PlutonicuserID || !userEmail) {
      setMessage({
        type: "error",
        text: "Missing user information. Please try logging out and logging back in.",
      });
      setIsLoading(false);
      return;
    }

    let isDisqualified = false;
    for (const q of questions) {
      if (q.disqualifyOn && answers[q.id] === q.disqualifyOn) {
        isDisqualified = true;
        break;
      }
    }

    try {
      const res = await axios.put(
        `${Env.REACT_APP_PYTHON_API_URL}/api/set-survey-completed`,
        {
          PlutonicuserID,
          email: userEmail,
          answers,
          qualified: !isDisqualified, // 👈 send flag
        },
        { withCredentials: true }
      );

      if (res.data.qualified === false) {
        setIsLoading(false);
        setMessage({
          type: "error",
          text: "Unfortunately, You do not qualify for this service. Please contact help@plutonichealth.co if you think this is a mistake.",
        });
        setTimeout(() => {
          // Only clear your app's keys
          localStorage.removeItem("PlutonicuserID");
          localStorage.removeItem("nickname");
          localStorage.removeItem("userType");
          localStorage.removeItem("surveyCompleted");
          localStorage.removeItem("email");

          if (typeof handleLogout === "function") {
      handleLogout();
    }

          // Redirect to external site
          window.location.href = "https://plutonic.co";
        }, 10000);
        return;
      }

      setIsLoading(false);
      setMessage({
        type: "success",
        text: "Registration Successful! Redirecting...",
      });
      setSurveyCompleted(true);
      localStorage.setItem("surveyCompleted", "true");
      localStorage.setItem("qualified", "true");

      setTimeout(() => {
        const messageElement = document.querySelector("[data-message]");
        if (messageElement) {
          messageElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);

      setTimeout(async () => {
  try {
    await verifyUserAccessFromServer();

    // small delay to allow React state to commit
    setTimeout(() => {
      navigate("/");
    }, 100);

  } catch (err) {
    console.error("SurveyForm.js: error event");
    navigate("/"); // fallback anyway
  }
}, 3000);
    } catch (err) {
      console.error("SurveyForm.js: error event");
      setIsLoading(false);
      setMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative"
      style={{
        background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
      }}
    >
      <div className="absolute top-0 left-0 w-full">
        <Navbar />
      </div>
      <div className="flex justify-center pt-20 pb-20">
        <div className="p-6 w-full max-w-lg text-white bg-black/80 rounded-3xl shadow-md mt-20">
          <h2 className="text-xl font-bold mb-4 text-center">
            Onboarding Survey
          </h2>

          <form onSubmit={handleSubmit}>
            {questions.map((q) => (
              <div key={q.id} className="mb-4 text-left">
                <p className="mb-2">{q.text}</p>
                <label className="mr-4">
                  <input
                    type="radio"
                    name={`q-${q.id}`}
                    value="Yes"
                    onChange={() => handleChange(q.id, "Yes")}
                    required
                  />{" "}
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name={`q-${q.id}`}
                    value="No"
                    onChange={() => handleChange(q.id, "No")}
                  />{" "}
                  No
                </label>
              </div>
            ))}

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full h-[48px] border border-[#22AAEE] rounded-full font-bold transition flex items-center justify-center ${
                isLoading
                  ? "bg-gray-600 text-gray-400 cursor-not-allowed"
                  : "text-[#22AAEE] hover:bg-[#22AAEE] hover:text-white"
              }`}
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>

          {message && (
            <div
              data-message
              className={`mt-6 p-4 rounded-lg text-center font-semibold text-lg border-2 ${
                message.type === "error"
                  ? "bg-red-900/50 text-red-200 border-red-400"
                  : "bg-green-900/50 text-green-200 border-green-400"
              }`}
            >
              {message.type === "success" && (
                <div className="flex items-center justify-center mb-2">
                  <svg
                    className="w-6 h-6 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{message.text}</span>
                </div>
              )}
              {message.type === "error" && (
                <div className="flex items-center justify-center">
                  <svg
                    className="w-6 h-6 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{message.text}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SurveyForm;
